import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "_id", headerName: "ID", width: 100 },
  { field: "restaurant_name", headerName: "Name", width: 190 },
  { field: "address", headerName: "Address", width: 130 },
  { field: "restaurantType", headerName: "Type", width: 130 },
  { field: "current_rating", headerName: "Rating", width: 130 },
  { field: "ownerName", headerName: "Owner", width: 130 },
];

export default function RestaurantTable({ rows, model, updateRecommendation }) {
  const tempmodel = model.map((r) => r._id);
  const [selectionModel, setSelectionModel] = useState(tempmodel);

  return (
    <>
      <div style={{ height: 400, width: "100%" }} className="pt-3">
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row._id}
          pageSize={5}
          rowsPerPageOptions={[5]}
          checkboxSelection
          selectionModel={selectionModel}
          onSelectionModelChange={setSelectionModel}
        />
      </div>
      <div>
        <button
          className="w-full bg-green-500 text-white py-2 px-3 rounded-sm border-none"
          onClick={(e) => updateRecommendation(selectionModel)}
        >
          Update Linked Restaurants
        </button>
      </div>
    </>
  );
}
